import { useState } from "react";
import { Phone, MessageCircle, X, Plus } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/i18n/translations";

export default function FloatingActions() {
    const { t, lang } = useLang();
    const [open, setOpen] = useState(true);

    return (
        <div
            data-testid="floating-actions"
            className="fixed bottom-5 end-5 z-40 flex flex-col items-end gap-3"
        >
            {open && (
                <>
                    <a
                        href={CONTACT.whatsappFor(lang)}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="float-whatsapp"
                        aria-label={`WhatsApp ${CONTACT.phoneRO_Display}`}
                        className="group inline-flex items-center gap-2 bg-[#25D366] text-white pe-4 ps-3 py-3 shadow-lg shadow-black/15 hover:shadow-xl transition-all hover:-translate-y-0.5"
                    >
                        <MessageCircle className="h-5 w-5" />
                        <span className="font-mono-tech text-[11px] uppercase tracking-[0.2em]">
                            {t.floating.whatsapp}
                        </span>
                    </a>
                    <a
                        href={`tel:${CONTACT.phoneDE_Tel}`}
                        data-testid="float-call"
                        aria-label={`Call ${CONTACT.phoneDE_Display}`}
                        className="group inline-flex items-center gap-2 bg-navy text-white pe-4 ps-3 py-3 shadow-lg shadow-black/15 hover:shadow-xl transition-all hover:-translate-y-0.5"
                    >
                        <Phone className="h-5 w-5" />
                        <span className="font-mono-tech text-[11px] uppercase tracking-[0.2em]">
                            {t.floating.call}
                        </span>
                    </a>
                </>
            )}
            <button
                onClick={() => setOpen((o) => !o)}
                data-testid="float-toggle"
                aria-label="Toggle floating actions"
                className="self-end h-10 w-10 inline-flex items-center justify-center bg-white text-navy border border-steel-200 shadow-md hover:bg-steel-50 transition"
            >
                {open ? <X className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
            </button>
        </div>
    );
}
